<template>
    <div>
        <div class="queryPanel">
            <div class="queryPanel_form" :class="{'queryPanel_form_show': showForm}">
                <Form
                    :form="queryForm"
                    @handleSelectChange="handleSelectChange"
                    @handlePressEnter="handlePressEnter"
                    @handleInputClear=handleInputClear
                    @handlePickerDateChange="handlePickerDateChange"
                ></Form>
            </div>
            <div class="queryPanel_btn">
                <a-dropdown-button size="small" @click="handle('search')">
                    <icon-search size="14" style="marginRight:5px;"/>
                    {{ $t('base.search') }}
                    <template #content>
                        <a-doption @click="handle('reset')">
                            <icon-refresh size="14" style="marginRight:5px;"/>
                            {{ $t('base.reset') }}
                        </a-doption>
                    </template>
                </a-dropdown-button>
            </div>
        </div>
        
        <Table
            :table="table"
            @changePage="changePage"
            @changePageSize="changePageSize"
        >
            <template v-slot:operate>
                <a-button type="primary" size="mini" v-permission="'setting.saleGoal.createDealerGoal'" @click="handle('create')">
                    <icon-plus-circle size="13" style="marginRight:5px;"/>
                    {{ $t('saleGoal.createGoal') }}
                </a-button>
            </template>

            <template v-slot:tableOperate="{ props }">
                <a-button type="primary" size="mini" v-permission="'setting.saleGoal.editDealerGoal'" @click="handle('edit', props.record)">
                    <icon-edit size="13" style="marginRight:5px;" />
                    {{ $t('base.edit') }}
                </a-button>
            </template>
        </Table>

        <!-- 新建目标 -->
        <a-modal
            v-model:visible="visible" 
            draggable
            :onBeforeOk="onBeforeOk"
        >
            <template #title>
                <div style="font-weight:bold">{{ $t('saleGoal.createGoal') }}</div> 
            </template>
            
            <Form
                :form="addForm"
                @handleSelectChange="handleSelectAddFormChange"
            ></Form>
        </a-modal>
        
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch } from 'vue';
    import { SaleGoalApi } from '@/api/SaleGoalApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
    import { DealerGoalQueryForm, AddDealerGoalForm } from './queryConfig/SaleGoalForm'
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n()

    const queryForm = reactive(DealerGoalQueryForm)
    const addForm = reactive(AddDealerGoalForm)
    const visible = ref(false)
    const table = ref({
        datas:[],
        columns:[
            {
                title: '#',
                dataIndex: 'No',
                key:'No',
                width:'100',
                align:'center',
            },
            {
                // title: '年份',
                title:t('saleGoal.year'),
                dataIndex: 'year',
                key:'year',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '国家',
                title:t('saleGoal.country'),
                dataIndex: 'country',
                key:'country',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '国家编码',
                title:t('saleGoal.countryCode'),
                dataIndex: 'country_code',
                key:'country_code',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },  
            {
                // title: '目标',
                title:t('saleGoal.goalSaleNumber'),
                dataIndex: 'goal',
                key:'goal',
                align:'center',
                ellipsis:true,
                tooltip:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width:'100',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                // x:1000,
                // y:700,
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:{
                current:1,
                pageSize:10,
                total:0,
                pageSizeOptions:[10, 20, 50, 100],
                showJumper:true,
                showPageSize:true,
                showTotal:true,
            },
        },
    })

    const handle = (type, row)=>{
        switch(type){
            case 'search':
                getDealerGoalList()
                break;
            case 'reset':
                queryForm.formField.forEach(item=>{
                    queryForm.formData[item.key] = ''
                })
                break;
            case 'create':
                addForm.formField.forEach(item=>{
                    addForm.formData[item.key] = ''
                    if(item.key == 'year' || item.key == 'country'){
                        item.disabled = false
                    }
                })
                visible.value = true
                let year = new Date().getUTCFullYear()
                let year_item = addForm.formField.find(i=> i.key == 'year')
                year_item.options = []
                year_item.options.push({
                    label: year,
                    value: year,
                })
                addForm.formData.year = year
                break;
            case 'edit':
                addForm.formField.forEach(item=>{
                    if(item.key == 'year' || item.key == 'country'){
                        item.disabled = true
                    }
                    addForm.formData[item.key] = row[item.key]
                })
                addForm.formData.id = row.id
                visible.value = true
                break;

        }
    }

    const changePage = (current)=>{
        table.value.configs.pagination.current = current
        getDealerGoalList()
    }

    const changePageSize = (pageSize)=>{
        table.value.configs.pagination.current = 1
        table.value.configs.pagination.pageSize = pageSize
        getDealerGoalList()
    }

    const handleSelectChange = ()=>{
        table.value.configs.pagination.current = 1
        getDealerGoalList()
    }

    const handleSelectAddFormChange = (val,opt,key)=>{
        console.log(val,opt,key,'val,opt,key')
        if(key == 'country'){
            let item = addForm.formField.find(i=> i.key == key)
            let optItem = item.options.find(i=> i.label == val)
            addForm.formData.country_code = optItem.code
        }
    }

    const getDealerGoalList = async ()=>{
        let param = {
            ...queryForm.formData
        }
        let page_num = table.value.configs.pagination.current
        let page_size = table.value.configs.pagination.pageSize
        table.value.configs.loading = true
        let res = await SaleGoalApi.getInstance().getDealerGoalList(param, page_num, page_size)
        if(res.code == 0){
            res.data.records.forEach((item, index)=>{
                item.No = index + 1
            })
            table.value.datas = res.data.records
            table.value.configs.loading = false
            table.value.configs.pagination.total = res.data.total
        }else{
            Message.error(res.msg)
        }
    }

    const onBeforeOk = async ()=>{

        if(!addForm.formData.year){
            Message.error(t('saleGoal.year') + ' ' + t('base.noEmpty'))
            return false
        }else if(!addForm.formData.country){
            Message.error(t('saleGoal.country') + ' ' + t('base.noEmpty'))
            return false
        }else if(addForm.formData.goal === ''){
            Message.error(t('saleGoal.goalSaleNumber') + ' ' + t('base.noEmpty'))
            return false
        }

        let param = {
            ...addForm.formData
        }
        console.log(param,'param')
        let res = await SaleGoalApi.getInstance().addDealerGoal([param])
        if(res.code == 0){
            Message.success(t('base.createSuccess'))
            getDealerGoalList()
        }else{
            Message.error(res.msg)
        }
    }

    // 获取国家下拉配置
    const getCountry = async ()=>{
        let res = await OrderApi.getInstance().getCountry({enable_flag:1})
        if(res.code == 0){
            let item = queryForm.formField.find(i=> i.key == 'country')
            let countryItem = queryForm.formField.find(i=> i.key == 'country_code')
            let addCountryItem = addForm.formField.find(i=> i.key == 'country')
            item.options = []
            countryItem.options = []
            addCountryItem.options = []
            res.data.forEach(i=>{
                item.options.push({
                    label:i.country,
                    value:i.country
                })
                addCountryItem.options.push({
                    label:i.country,
                    value:i.country,
                    code:i.country_code
                })
                countryItem.options.push({
                    label:i.country_code,
                    value:i.country_code
                })
            })
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        queryForm.formField.forEach(i=>{
            if(i.key == 'year'){
                queryForm.formData[i.key] = `${new Date().getUTCFullYear()}` 
            }
        })
        
        getCountry()
        getDealerGoalList()

        
    })

</script>

<style lang="less" scoped>
.queryPanel{
    display: flex;
    // margin-bottom:7px;
    padding:7px;
    background: #fff;
    border-bottom: 1px dashed #ccc;

    .queryPanel_form{
        display: flex;
        flex:14;
        flex-direction: column;
        height: 33px;
        overflow: hidden;

        /deep/ .arco-form-layout-inline .arco-form-item{
            margin-bottom:0;
        }
    }

    .queryPanel_form_show{
        height: auto;
        overflow: visible;
    }

    .queryPanel_btn{
        display: flex;
        flex:1;
        // flex-direction: column;
        justify-content: center;
        align-items: center;
        border-left:1px solid #eee;
        padding-left:5px;

        .openBtn{
            display: inline-block;
            padding: 3px 10px;
            margin: 2px 5px 0 5px;
            width: 80px;
            text-align: center;
            color: #165dff;
            cursor: pointer;
            border: 1px solid #165dff;
            border-radius:2px;
        }
    }

    /deep/ .arco-form-item-label-col > .arco-form-item-label{
        font-size:12px;
    }

    /deep/ .arco-form-item-layout-inline{
        margin-right: 0;
    }
    
    .form_btn{
        margin:5px 5px 3px;
        width:70px;
    }
}

/deep/ .operayeBox {
    margin-bottom: 7px;
    background: #fff;
    padding: 5px 24px 5px;
}

/deep/ .arco-btn-group{
    vertical-align: bottom;
}
/deep/ .arco-btn-group .arco-btn:first-child,
/deep/ .arco-btn-group .arco-btn:last-child{
    background: #165dff;
    color: #fff;
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .arco-pagination-options .arco-select,
/deep/ .arco-pagination-jumper .arco-pagination-jumper-input input{
    background: #e7e7e7;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}
</style>